<ngx-spinner
  bdColor="rgba(0, 0, 0, 0)"
  template=" <img src='assets/images/spinner.gif' />"
>
  <!-- <p style="color: white;">{{ spinnerText }}</p> -->
</ngx-spinner>
<div class="container">
  <form class="row" name="form" [formGroup]="form">
    <div style="width: 100%; display: flex; align-items: baseline">
      <div class="box">
        <div class="box-title">
          <h4>{{ 'What1' | translate }}<span>*</span></h4>
          <p>{{ 'DescribeThePhenomenonWhatDoYouSee' | translate }}</p>
        </div>
        <div title="{{ sixwtwoh?.What }}">
          <mat-form-field class="w-100">
            <textarea
              (input)="concatProblemStatement()"
              matInput
              formControlName="what"
              [(ngModel)]="sixwtwoh.What"
              class="textarea-input"
            ></textarea>
            <mat-error>{{ 'WhatIsRequired' | translate }}</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="box">
        <div class="box-title">
          <h4>{{ 'Where2' | translate }}<span>*</span></h4>
          <p>{{ 'TheTransformationsWhereTheLossOccursWhereNot' | translate }}</p>
        </div>
        <div title="{{ sixwtwoh?.Where }}">
          <mat-form-field class="w-100">
            <textarea
              (input)="concatProblemStatement()"
              matInput
              formControlName="where"
              [(ngModel)]="sixwtwoh.Where"
              class="textarea-input"
            ></textarea>
            <mat-error>{{ 'WhereIsRequired' | translate }}</mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div style="width: 100%; display: flex; align-items: baseline">
      <div class="box">
        <div class="box-title">
          <h4>{{ 'When3' | translate }}<span>*</span></h4>
          <p>{{ 'StartupNormalOperationWhenDidTheProblemStart' | translate }}</p>
        </div>
        <div title="{{ sixwtwoh?.When }}">
          <mat-form-field class="w-100">
            <textarea
              (input)="concatProblemStatement()"
              matInput
              formControlName="when"
              [(ngModel)]="sixwtwoh.When"
              class="textarea-input"
            ></textarea>
            <mat-error>{{ 'WhenIsRequired' | translate }}</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="box">
        <div class="box-title">
          <h4>{{ 'Which4' | translate }}<span>*</span></h4>
          <p>{{ 'BrandsSKUSFormatsMaterialSAffectedWhichNot' | translate }}</p>
        </div>
        <div title="{{ sixwtwoh?.Which }}">
          <mat-form-field class="w-100">
            <textarea
              (input)="concatProblemStatement()"
              matInput
              formControlName="which"
              [(ngModel)]="sixwtwoh.Which"
              class="textarea-input"
            ></textarea>
            <mat-error>{{ 'WhichIsRequired' | translate }}</mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div style="width: 100%; display: flex; align-items: baseline">
      <div class="box">
        <div class="box-title">
          <h4>{{ 'Who5' | translate }}<span>*</span></h4>
          <p>{{ 'VariationAmongTeamsPeopleOther' | translate }}</p>
        </div>
        <div title="{{ sixwtwoh?.Who }}">
          <mat-form-field class="w-100">
            <textarea
              (input)="concatProblemStatement()"
              matInput
              formControlName="who"
              [(ngModel)]="sixwtwoh.Who"
              class="textarea-input"
            ></textarea>
            <mat-error>{{ 'WhoIsRequired' | translate }}</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="box">
        <div class="box-title">
          <h4>{{ 'How6' | translate }}<span>*</span></h4>
          <p>{{ 'CircumstancesOfTheLossFailureModule' | translate }}</p>
        </div>
        <div title="{{ sixwtwoh?.How }}">
          <mat-form-field class="w-100">
            <textarea
              (input)="concatProblemStatement()"
              matInput
              formControlName="how"
              [(ngModel)]="sixwtwoh.How"
              class="textarea-input"
            ></textarea>
            <mat-error>{{ 'HowIsRequired' | translate }}</mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div style="width: 100%; display: flex; align-items: baseline">
      <div class="box">
        <div class="box-title">
          <h4>{{ 'HowMuch7' | translate }}</h4>
          <p>{{ 'MagnitudeNumberFrequencyAmount' | translate }}</p>
        </div>
        <div title="{{ sixwtwoh?.HowMuch }}">
          <mat-form-field class="w-100">
            <textarea
              (input)="concatProblemStatement()"
              matInput
              type="number"
              formControlName="howMuch"
              [(ngModel)]="sixwtwoh.HowMuch"
              class="textarea-input"
            ></textarea>
          </mat-form-field>
        </div>
      </div>
      <div class="box">
        <div class="box-title">
          <h4>{{ 'ToWhom8' | translate }}</h4>
          <p>{{ 'LinesSystemsOperationsAffected' | translate }}</p>
        </div>
        <div title="{{ sixwtwoh?.ToWhom }}">
          <mat-form-field class="w-100">
            <textarea
              (input)="concatProblemStatement()"
              matInput
              formControlName="whom"
              [(ngModel)]="sixwtwoh.ToWhom"
              class="textarea-input"
            ></textarea>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div style="width: 100%; display: flex">
      <div class="box" style="width: 98%">
        <div class="bg-primary">
          <h4>{{ 'NewRefocusedProblemStatement' | translate }} <span>*</span></h4>
        </div>
        <div title="{{ sixwtwoh?.ProblemStatement }}">
          <mat-form-field class="w-100">
            <textarea
              matInput
              formControlName="problemStatement"
              [(ngModel)]="sixwtwoh.ProblemStatement"
              class="textarea-input"
            ></textarea>
            <mat-error>{{ 'ProblemStatementIsRequired' | translate }}</mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
  </form>
</div>
